<template>
  <!-- ModalSheet already opens with present() rather than :is-open, which a sheet
       on a routed page needs (docs/ION_MODAL_PATTERN.md). No button, as in the T and
       P1c frames: it closes on a swipe or a backdrop tap. -->
  <ModalSheet
    :modelValue="modelValue"
    tone="campaign"
    @update:modelValue="$emit('update:modelValue', $event)"
  >
    <div class="flex flex-col gap-[16px]" :data-test="testId">
      <DsHeading
        v-if="title"
        tag="h2"
        :class="[
          'font-black text-campaign-ink',
          large
            ? 'text-[28px] leading-[32px] tracking-[-0.02em]'
            : 'text-[24px] leading-[28px] tracking-[-0.01em]',
        ]"
      >
        {{ title }}
      </DsHeading>
      <slot />
    </div>
  </ModalSheet>
</template>

<script>
import { Heading as DsHeading } from '@team-hogc/hogc-one-design-system';
import ModalSheet from '@/components/common/ModalSheet.vue';

// The BF2026 pledge's explainer sheets: what pledging as a couple means (T), why a
// couple pledge asks for the partner's details (P1c), and My BF Fulfilment's ⓘs,
// which a phone cannot hover.
export default {
  name: 'PledgeInfoSheet',

  components: { DsHeading, ModalSheet },

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    // Left out for a tooltip's one line, which has no title of its own.
    title: {
      type: String,
      default: '',
    },
    // P1c's larger title (28/32); T's is 24/28.
    large: {
      type: Boolean,
      default: false,
    },
    testId: {
      type: String,
      default: null,
    },
  },

  emits: ['update:modelValue'],
};
</script>
